module.exports = __webpack_public_path__ + "media/huntling.4a198dfe.webm";